import {
  CMHeadingContainer,
  CMBox,
  CMBoxcontainer,
  CMFooter,
  CMImage,
  CMOffer,
  handlePrev,
} from "./visa-funds.styles";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import Image from "../../image/image.component";

const VisaFunds = ({ handleNext, visaCard, footer, handlePrev }) => {
  return (
    <>
      <CMBoxcontainer>
        <CMHeadingContainer>
          <CMImage>
            <Image src={visaCard} />
          </CMImage>
        </CMHeadingContainer>
        <CMBox>
          <h4>Add to my account</h4>
          <div className="container">
            <div className="column1">
              <input type="text" id="dollar" maxLength={1} value={"$"} />
            </div>
            <div className="column2">
              <input type="number" id="num1" maxLength={3} value={200} />
            </div>
          </div>
        </CMBox>
      </CMBoxcontainer>
      <CMFooter>
        <h5>{footer}</h5>
      </CMFooter>
      <CMOffer>
        <Button
          className="BackButton"
          buttonType={BUTTON_TYPE_CLASSES.TextButton}
          color="blue"
          onClick={handlePrev}
          style={{ border: "none" }}
        >
          &lt; Back
        </Button>
        <Button onClick={handleNext} color="blue" className="ContinueButton">
          Continue to payment
        </Button>
      </CMOffer>
    </>
  );
};
export default VisaFunds;
